var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTpWorkIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44206C24.9974 8.76455 26.0022 8.76456 26.4803 9.44207L45.4736 36.3581C46.0345 37.153 45.466 38.25 44.4931 38.25H6.50648C5.53358 38.25 4.96508 37.153 5.52601 36.3581L24.5193 9.44206Z",
    fill: "#D44A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6467 6.20505L40.1842 11.7726C43.7967 13.3663 43.7967 16.0013 40.1842 17.5951L27.6467 23.1626C26.223 23.8001 23.8855 23.8001 22.4617 23.1626L9.92422 17.5951C6.31172 16.0013 6.31172 13.3663 9.92422 11.7726L22.4617 6.20505C23.8855 5.56755 26.223 5.56755 27.6467 6.20505Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 23.375C6.375 25.16 7.71375 27.2212 9.35 27.9437L23.7787 34.3613C24.8837 34.85 26.1375 34.85 27.2213 34.3613L41.65 27.9437C43.2863 27.2212 44.625 25.16 44.625 23.375",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 34C6.375 35.9763 7.54375 37.7612 9.35 38.5687L23.7787 44.9863C24.8837 45.475 26.1375 45.475 27.2213 44.9863L41.65 38.5687C43.4563 37.7612 44.625 35.9763 44.625 34",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon05);
export default __webpack_public_path__ + "static/media/tp-work-icon05.030fd07b9f88dc132d8f9da1c710251b.svg";
export { ForwardRef as ReactComponent };